import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const HeartSolidIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="M4.242 1.313a4.5 4.5 0 0 1 3.74 1.068l.027.025.026-.023a4.5 4.5 0 0 1 3.548-1.08l.184.028a4.498 4.498 0 0 1 2.522 7.502l-.135.139-.036.03-5.585 5.532a.75.75 0 0 1-.984.062l-.07-.062L1.86 8.97a4.498 4.498 0 0 1 2.381-7.657" />
  </svg>
);
HeartSolidIcon.id = 'HeartSolidIcon';
HeartSolidIcon.displayName = 'HeartSolidIcon';
export default HeartSolidIcon;
